import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyCode, CurrencyDisplayState } from './models/currency';

@Pipe({ name: 'bravumCurrency' })
export class CurrencyDisplayPipe implements PipeTransform {
  transform(
    originalAmount: number | string | null | undefined,
    state: CurrencyDisplayState,
    locale = 'es-CL'
  ): string {
    const amount = Number(originalAmount);
    const rate = Number(state?.rate);
    const currency = state?.selectedCurrency || state?.baseCurrency || 'CLP';
    const converted = Number.isFinite(amount) ? amount * (Number.isFinite(rate) && rate > 0 ? rate : 1) : 0;
    return this.format(converted, currency, locale);
  }

  private format(value: number, currency: CurrencyCode, locale: string): string {
    const fractionDigits = currency === 'CLP' ? 0 : 2;
    const symbols: Record<CurrencyCode, string> = {
      CLP: '$',
      USD: 'US$',
      MXN: 'MX$',
      EUR: '€'
    };
    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'code',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    }).formatToParts(value)
      .map(part => part.type === 'currency' ? symbols[currency] : part.value)
      .join('');

    return currency === 'CLP' ? `${formatted} CLP` : formatted;
  }
}
